export default "__VITE_ASSET__PoKwArRa__"